export default function setAvatar(info: any) {
  sessionStorage.setItem("avatar_img", info);
}
